'use client';

import type { FC, ReactNode } from 'react';
import { cn } from '@/app/utils';

interface ToolFormContainerProps {
  title: string;
  description?: string;
  exampleSection?: ReactNode;
  mediaSection: ReactNode;
  settingsSection?: ReactNode;
  submitButton: ReactNode;
  className?: string;
  contentClassName?: string;
  submitButtonClassName?: string;
  children?: ReactNode;
}

export const ToolFormContainer: FC<ToolFormContainerProps> = ({
  title,
  description,
  exampleSection,
  mediaSection,
  settingsSection,
  submitButton,
  className,
  contentClassName,
  submitButtonClassName,
  children,
}) => {
  return (
    <>
      <div className={cn('relative flex w-full flex-1 flex-col gap-6 px-6 pb-5 text-sm', 'sm:gap-4 sm:p-4', className)}>
        <div className={cn('flex flex-col gap-5', contentClassName)}>
          <div className="space-y-2">
            <h1 className="font-semibold text-[32px] text-system-white leading-[1.4]">{title}</h1>
            {description && <p className="text-sm text-system-white/40 leading-[1.4]">{description}</p>}
          </div>

          {exampleSection}

          {mediaSection}

          {settingsSection}

          {children}
        </div>
      </div>

      <div
        className={cn(
          'absolute bottom-0 left-0 z-10 flex w-full justify-center px-10 pt-4 [background:linear-gradient(180deg,rgba(2,11,19,0)_0%,#020B13_76.04%)] sm:px-0 lg:pt-3',
          submitButtonClassName,
        )}
      >
        {submitButton}
      </div>
    </>
  );
};
